module.exports = __webpack_public_path__ + "img/erp_tab03_img_r.6a86e201.png";